exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".panel{height:100%;width:100%}.panel,.panel.panel-form,.panel.panel-list{display:block}.panel .panel-header{border-top:.5px solid rgba(0,0,0,.05);margin-top:40px;position:relative;margin-left:20px;margin-bottom:15px}.panel .panel-header button{display:none}.panel .panel-header h1{font-family:Helvetica Neue,Arial,Helvetica,sans-serif;text-transform:uppercase;color:#404040;letter-spacing:-1px;font-size:14px;background-color:#fff;position:absolute;top:-11px;left:0;padding-right:15px}.panel.panel-login form{padding:0 20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader?modules&localIdentName=[name]---[local]---[hash:base64:5]!./client/styles/panels.styl
// module id = 516
// module chunks = 0